import React, { Component } from "react";
import SearchIcon from "@material-ui/icons/Search";
import BackIcon from "@material-ui/icons/KeyboardArrowLeft";
import LocationIcon from "@material-ui/icons/LocationOnOutlined";
import CloseIcon from "@material-ui/icons/Close";
import TimeIcon from "@material-ui/icons/AccessTime";
import InputBase from "@material-ui/core/InputBase";
import TablePagination from "@material-ui/core/TablePagination";
import axios from "axios";
import { SEARCH_ARRANGEMENT_URL, ROOM_LIST_URL } from "../actions/types";
import Button from "@material-ui/core/Button";
import { DatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import moment from "moment";
import "moment/locale/zh-cn";
import MomentUtils from "@date-io/moment";
class RoomSearch extends Component {
  state = {
    page: 0,
    pageSize: 10,
    total: 0,
    arrangeMent: [],
    meetingRoom: [],
    purpose: "",
    detailRoom: {},
    date: null,
    filter: false,
    hasSearch: false
  };
  componentDidMount() {
    axios.get(ROOM_LIST_URL).then(res => {
      // console.log(res.data);
      this.setState({ meetingRoom: res.data });
    });
  }
  searchArrangement() {
    const { purpose, detailRoom, date, page, pageSize } = this.state;
    if (purpose === "" && detailRoom.id === undefined && date === null) {
      this.setState({ arrangeMent: [] });
      return false;
    }
    const data = {
      pageIndex: page + 1,
      pageSize: pageSize,
      purpose: purpose,
      id: detailRoom.id,
      date: date
    };
    axios({ method: "post", url: SEARCH_ARRANGEMENT_URL, data: data }).then(res => {
      this.setState({ arrangeMent: res.data.data, total: res.data.total, hasSearch: true });
    });
  }
  handleDateChange(date) {
    this.setState({ date: date.format("YYYY-MM-DD") }, () => this.searchArrangement());
  }
  addBodyFixed() {
    // document.body.style.position = "fixed";
    this.refs.dp.open();
  }
  render() {
    return (
      <div>
        <div className="search-header">
          <div className="search-div">
            <div className="back-icon">
              <BackIcon
                onClick={() => {
                  this.props.history.go(-1);
                }}
              />
            </div>
            <InputBase
              onChange={e => {
                this.setState({ purpose: e.target.value });
              }}
              placeholder="搜索会议标题"
              className="search-input"
              autoFocus={true}
            />
            <Button
              className="search-icon"
              onClick={() => {
                this.searchArrangement();
              }}
            >
              <SearchIcon />
            </Button>
          </div>
        </div>
        <div className="search-button">
          {this.state.detailRoom.id ? (
            <Button className="search-detailRoom" variant="outlined" onClick={() => {this.setState({ filter: true });}}>
              {this.state.detailRoom.name}
              <CloseIcon
                style={{ fontSize: 14, marginLeft: 4 }}
                onClick={e => {
                  this.ClearRoom(e);
                }}
              />
            </Button>) : (
            <Button variant="outlined" onClick={() => {
                this.setState({ filter: true });
              }}>
              地点</Button>
          )}
          <Button variant="outlined" onClick={() => {
              this.addBodyFixed();}}>
            {this.state.date ? (<React.Fragment>
                {this.state.date}
                <CloseIcon
                  style={{ fontSize: 14, marginLeft: 4 }}
                  onClick={e => {
                    this.ClearTime(e);
                  }}
                />
              </React.Fragment>) : ("开始时间")}
          </Button>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              margin="normal"
              value={this.state.date}
              style={{ display: "none" }}
              cancelLabel="取消"
              okLabel="确定"
              onClose={() => {
                document.body.style.position = "";
              }}
              onChange={e => this.handleDateChange(e)}
              ref="dp"
            />
          </MuiPickersUtilsProvider>
        </div>
        {this.renderArrangement()}
        {this.renderFilterDiv()}
      </div>
    );
  }
  renderArrangement() {
    const { arrangeMent, total, pageSize, page, hasSearch } = this.state;
    if (arrangeMent.length !== 0) {
      const arrangeMentData = arrangeMent.map((data, idx) => {
        return (
          <div key={idx} className="arrangement-data">
            <div className="data-div-1">{data.purpose}</div>
            <div className="data-div-2">
              <LocationIcon style={{ fontSize: 12, marginRight: 4 }} />
              <span>{data.name}</span>
            </div>
            <div className="data-div-3">
              <TimeIcon style={{ fontSize: 12, marginRight: 4 }} />
              <span>
                {moment(data.start).format("MM 月 DD 日 HH:mm")} - {moment(data.end).format("HH:mm")}
              </span>
            </div>
          </div>
        );
      });
      return (
        <div className="search-arrangement">
          {arrangeMentData}
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={total}
            rowsPerPage={pageSize}
            page={page}
            backIconButtonProps={{
              "aria-label": "Previous Page"
            }}
            nextIconButtonProps={{
              "aria-label": "Next Page"
            }}
            labelRowsPerPage={<span>每页数目</span>}
            onChangePage={(e, page) => this.handleChangePage(e, page)}
            onChangeRowsPerPage={e => this.handleChangeRowsPerPage(e)}
          />
        </div>
      );
    } else {
      if (hasSearch) {
        return <div className="search-arrangement">暂无符合条件的会议记录</div>;
      }
    }
  }
  // 会议室筛选
  renderFilterDiv() {
    const { meetingRoom, detailRoom, filter } = this.state;
    return (
      <div className="filter-div" style={{ transform: filter ? "scale(1)" : "scale(0)" }}>
        <div className="filter-top">
          <div className="filter-close" onClick={() => this.setState({ filter: false })}>
            <CloseIcon style={{ fontSize: 14, verticalAlign: "middle" }} />
          </div>
          <span>会议室筛选</span>
        </div>
        <div className="filter-contain">
          <div className={detailRoom.id ? "filter-all" : "filter-all active"} onClick={() => this.selectAll()}>全部</div>
          <div className="filter-room-div">
            {meetingRoom.map((room, idx) => {
              return (
                <div className={detailRoom.id === room.id ? "filter-room-detail active" : "filter-room-detail"} onClick={() => this.selectDetailRoom(room)} key={idx}>
                  {room.mediaList[0] && <img src={room.mediaList[0].url} width="100%" alt="roomImg" />}
                  {room.name}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }
  handleChangePage(event, page) {
    this.setState({ page }, () => this.searchArrangement());
  }
  handleChangeRowsPerPage(event) {
    this.setState({ pageSize: event.target.value }, () => this.searchArrangement());
  }
  // 选择房间
  selectAll() {
    this.setState({ detailRoom: {}, filter: false }, () => this.searchArrangement());
  }
  selectDetailRoom(room) {
    this.setState({ detailRoom: room, filter: false }, () => this.searchArrangement());
  }
  ClearRoom(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ detailRoom: {} }, () => this.searchArrangement());
  }
  ClearTime(e) {
    e.stopPropagation();
    e.preventDefault();
    this.setState({ date: null }, () => this.searchArrangement());
  }
}
export default RoomSearch;
